export default __webpack_public_path__ + "ed409e61682847d1eec6d9b795caad3a.svg";